/**
 * Extracted from sections/ns-reviews-with-filters.liquid (inline <script> at line 631).
 * Moved verbatim into a cacheable, deferred asset so the browser can cache it
 * across page loads and stop parsing/compiling it during the HTML parse.
 * Found while fixing INP on the PDP (inline JS was the largest first-party
 * main-thread cost). Logic intentionally unchanged.
 */

// --- original inline block #1 (was at sections/ns-reviews-with-filters.liquid:631) ---
(function () {
  document.addEventListener('DOMContentLoaded', function () {
    const buttons = document.querySelectorAll('.review-section-with-filter__filter-btn');
    const cards = document.querySelectorAll('.review-section-with-filter__card');
    const cardsContainer = document.querySelectorAll('.review-section-with-filter__grid')[0];

    buttons.forEach(button => {
      button.addEventListener('click', () => {
        const category = button.getAttribute('data-filter');

        buttons.forEach(btn => btn.classList.remove('active'));
        button.classList.add('active');

        cardsContainer.setAttribute('category', category)
        cards.forEach(card => {
          if (category == "all"){
             card.style.display = 'flex';
          }
          else{
          if (card.getAttribute('data-category') === category) {
            card.style.display = 'flex';
          } else {
            card.style.display = 'none';
          }
        }
        });
      });
    });
   
  const loadMoreBtn = document.querySelector("button.review-section-with-filter__load-more");
  const reviewGrid = document.querySelector(".review-section-with-filter__grid");

  if (loadMoreBtn && reviewGrid) {
    loadMoreBtn.addEventListener("click", function () {
      reviewGrid.classList.add("show-more-reviews"); // replace with the class you want to add
    });
  }

  });
})();
